module.exports = __webpack_public_path__ + "assets/img/Quorn-Pillar-Page-Resource-w540.fc4f53e8.webp";